// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { MathUtils } from './MathUtils';
export class _DocumentUtils {
    constructor() {
        this.ACC_DETAILS_SEPARATOR = '/';
        this.TABLE_GREEN = 'positive-value';
        this.TABLE_RED = 'negative-value';
        this.TABLE_WHITE = 'neutral-value';
    }
    isInputActive() {
        return document.activeElement instanceof HTMLInputElement;
    }
    blurInput() {
        const inputElement = document.activeElement;
        inputElement === null || inputElement === void 0 ? void 0 : inputElement.blur();
    }
    getSignedStyle(value) {
        if (value > 0) {
            return 'green';
        }
        else if (value < 0) {
            return 'red';
        }
        else {
            return '';
        }
    }
    getColorTableStyle(value) {
        if (!isValidNumber(value)) {
            return DocumentUtils.TABLE_WHITE;
        }
        if (value > 0) {
            return DocumentUtils.TABLE_GREEN;
        }
        else if (value < 0) {
            return DocumentUtils.TABLE_RED;
        }
        else {
            return DocumentUtils.TABLE_WHITE;
        }
    }
    getColorTableForLiveLeverage(value) {
        if (!isValidNumber(value)) {
            return DocumentUtils.TABLE_WHITE;
        }
        const _value = MathUtils.TruncateDouble(value, 2);
        if (_value > 1) {
            return DocumentUtils.TABLE_RED;
        }
        else if (_value >= 0 && _value <= 1) {
            return DocumentUtils.TABLE_GREEN;
        }
        else {
            return DocumentUtils.TABLE_WHITE;
        }
    }
    getTrendStyle(isUpTrend) {
        if (isUpTrend === undefined) {
            return '';
        }
        return isUpTrend ? 'green' : 'red';
    }
}
export const DocumentUtils = new _DocumentUtils();
